import { CompaniesDirectoryPage } from "@/components/companies/companies-directory-page";

/** Directory — immutable company catalog search. */
export function DirectoryCompaniesPage() {
  return <CompaniesDirectoryPage scope="directory" />;
}
